export default __webpack_public_path__ + "static/media/tbank.a6bf1f5f.svg";